/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { atom } from 'jotai'

import { DEFAULT_REGION, Region } from '@/utils/regions'

/**
 * An atom that stores the currently selected region. Hydrated from the URL
 * region slug (via x-region header) on each page load by RegionHydration.
 */
const selectedRegionAtom = atom<Region>(DEFAULT_REGION)
selectedRegionAtom.debugLabel = 'selectedRegionAtom'

export { selectedRegionAtom }
